<template>
  <div class="container">
    <!-- 顶部 -->
    <van-sticky>
      <div class="top">
        <van-icon name="arrow-left" color="var(--text_color)" size="20" @click="$router.go(-1)" />
        <div class="title"><span @click="onShowProduct"><svg-icon class-name="exc" icon-class="exchanges" /></span>{{
          proInfo.name }} <div class="closetime" v-if="proInfo.isCloseTime">{{ $t('trade').CloseTime }}</div>
        </div>
        <!-- 收藏 -->
        <svg-icon class-name="exc" icon-class="collect" v-if="!proInfo.isOptional" @click="editSingleOptionalProduct(true)" />
        <svg-icon class-name="exc" icon-class="collect_s" v-else @click="editSingleOptionalProduct(false)" />
      </div>
    </van-sticky>
    <!-- 产品数据 -->
    <div class="proNum">
      <div class="left">
        <div class="price" :class="proInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ proInfo.newPrice }}</div>
        <div class="flu" :class="proInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ proInfo.priceChangeRatio }}%</div>
      </div>
      <div class="right">
        <div class="num">{{ $t('trade').high }}<span>{{ proInfo.high }}</span></div>
        <div class="num">{{ $t('trade').low }} <span>{{ proInfo.low }}</span> </div>
        <div class="num">{{ $t('trade').vol }}<span>{{ proInfo.volume | formatNumber }}</span></div>
      </div>
    </div>
    <!-- k线 -->
    <div class="kBox">
      <div class="data-mode-box">
        <div v-for="(dItem, dIndex) in dataModeList" :key="dIndex" :class="{ dataMoeActive: dataMoeActiveIndex === dIndex }" @click="changedataMode(dIndex)">
          {{ dItem.name }}
        </div>
      </div>
      <tradingview ref="refTradingview" class="tradingviewView" />
    </div>
    <div class="line"></div>
    <!-- 深度成交合约 -->
    <div class="positionTitle">
      <!-- <span :class="activePos == 0 ? 'active' : ''" @click="activePos = 0">{{ $t('trade').profundity }}</span> -->
      <span :class="activePos == 1 ? 'active' : ''" @click="activePos = 1">{{ $t('trade').deal }}</span>
      <!-- <span :class="activePos == 2 ? 'active' : ''" @click="activePos = 2">{{ $t('trade').contract }}</span> -->
    </div>
    <!-- 成交 -->
    <div class="orderBook">
      <!-- 标题 数量 价格-->
      <div class="tit"><span>{{ $t('market').time }}</span><span>{{ $t('trade').limitMsg }}</span><span>{{
        $t('trade').num }}</span></div>
      <!-- 买盘 -->
      <van-skeleton title :row="16" :loading="skeletonLoading">
        <div v-for="(order, index) in dealOrders" :key="'buy-' + index" class="orderRow">
          <div class="time">{{ order.date * 1000 | getHourTime }}</div>
          <div class="price" :class="order.type">{{ order.newPrice }}</div>
          <div class="quantity">{{ order.vol2 | formatNumber }}</div>
        </div>
      </van-skeleton>
    </div>
    <!-- 立即交易 -->
    <div class="btns">
      <van-button block @click="$router.push({ name: 'Trade', query: { id: productId } })">{{ $t('trade').TradeNow
      }}</van-button>
    </div>
    <!-- 产品列表 -->
    <van-popup v-model="showProList" closeable position="bottom" :style="{ overflow: 'hidden' }" @close="getProductInfo">
      <div class="pro_list">
        <!-- 搜索 -->
        <div class="serarchInfo">
          <!-- 搜索 -->
          <van-search v-model="searchValue" shape="round" background="var(--background_color)" :placeholder="$t('public').search" @search="onSearch" @cancel="onSearch" @clear="onSearch" @input="onSearch" />
        </div>
        <!-- 顶部 -->
        <div class="topInfo">
          <!-- 行情分类 -->
          <div class="proTab"><span v-for="(item, index) in tabsMarket" :key="`tabma${index}`" :class="activeMarket == item.value ? 'active' : ''" @click="changeMarketTab(item.value)">{{ item.name
              }}</span></div>
          <!-- 产品业务 -->
          <div class="protypeTab">
            <div class="left">
              <span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{
                  item.name
                }}</span>
            </div>
            <svg-icon class-name="svgs" icon-class="edit" v-if="activeMarket == 0 && !showAddSelect" @click="$router.push({ name: 'MySelect' })" />
          </div>
          <!-- 产品类型 -->
          <div class="tabs" v-if="(activeBusiness == 2||activeBusiness == 4) && tabsType.length > 2"><span v-for="(item, index) in tabsType" :key="`tabtype${index}`" :class="activeType == item.value ? 'active' : ''" @click="changeTypeTab(item.value)">{{ item.name
              }}</span>
          </div>
          <!-- 产品标题 -->
          <div class="title">
            <div class="name">{{ $t('market').product }}</div><span>{{ $t('market').Latestprice }}</span><span>{{
              $t('market').volume }}</span><span>{{ $t('market').ChangeRatio }}</span>
          </div>
        </div>
        <!-- 添加自选 -->
        <div class="addSelectBtn" v-if="activeMarket == 0 && showAddSelect">
          <van-button block @click="$router.push({ name: 'MySelect', query: { i: true } })">{{ $t('market').Addoptional
          }}</van-button>
        </div>
        <!-- 产品列表 -->
        <div class="productInfo" :style="'height: calc(90vh - ' + ((activeBusiness == 2||activeBusiness == 4)  && tabsType.length > 2 ? 250 : 210) + 'px);'">
          <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="onGetProductList" :immediate-check="false">
            <div class="item" v-for="(item, index) in pList" :key="`pro${index}`" @click="selectProduct(item.productId)">
              <div class="name"><img :src="baseUrl + item.logoUrl" />{{ item.name }} </div>
              <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.newPrice }}</span>
              <span>{{ item.volume | formatNumber }}</span>
              <span :class="item.priceChangeRatio > 0 ? 'greenbg' : 'redbg'" class="ratio">{{ item.priceChangeRatio
              }}%</span>
            </div>
          </van-list>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
import productApi from '@/api/product'
import systemApi from '@/api/system'
import Tradingview from "@/components/Tradingview/Tradingview";
import { webSocket } from "@/mixins/webSocket.js";

export default {
  mixins: [webSocket],
  components: {
    Tradingview,
  },
  data() {
    return {
      skeletonLoading: true,
      baseUrl: window.baseURL,
      activePos: 1,
      timer: null,
      dealOrders: [],
      userInfo: { balance: 0 },
      showProList: false,
      searchValue: '',
      //行情分类
      activeMarket: 1,
      tabsMarket: [{
        name: this.$t('market').market,
        value: 1
      }, {
        name: this.$t('market').optional,
        value: 0
      },],
      //产品业务
      activeBusiness: 1,
      tabsBusiness: [{
        name: this.$t('public').USDTcontract,
        value: 1
      },
      //  {
      //   name: this.$t('public').Fiatcurrencycontract,
      //   value: 2
      // },
      {
        name: this.$t('public').spot,
        value: 3
      }, {
        name: this.$t('public').secondContract,
        value: 4
      }],
      //产品类型
      activeType: '',
      tabsType: [{
        name: this.$t('public').All,
        value: ""
      }],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      pList: [],
      showAddSelect: false,
      productId: '1',
      tabActive: 0,
      proInfo: {
      },
      // K线时间
      dataModeList: [{
        name: '1' + this.$t('trade').smallMin,
        value: "1"
      }, {
        name: '5' + this.$t('trade').smallMin,
        value: "5"
      }, {
        name: '15' + this.$t('trade').smallMin,
        value: "15"
      }, {
        name: '30' + this.$t('trade').smallMin,
        value: "30"
      }, {
        name: '1' + this.$t('trade').hour,
        value: "60"
      }, {
        name: '1' + this.$t('trade').dayMin,
        value: "1D"
      }
      ],
      dataMoeActiveIndex: 0,
      line: '1',
      Kname: '',
    }
  },
  computed: {
    ...mapGetters(['basicConfig', 'connection', 'baseMsg']),
  },
  mounted() {
    if (this.$route.query.id) {
      this.productId = this.$route.query.id
    }
    this.Kname = this.dataModeList[0]
    this.getConfig()
    this.getProductInfo()
    this.timer = setInterval(this.getProductDealList, 1000);
  },
  //销毁之前
  beforeDestroy() {
    console.log('销毁kline');
    this.websockClose();
    clearInterval(this.timer);
  },
  methods: {
    // 查询产品成交列表
    async getProductDealList() {
      var dealOrders = []
      const res = await productApi.getProductDealList({ productId: this.productId })
      this.skeletonLoading = false
      res.data.sellOrders.forEach((sItem) => {
        sItem.type = 'red'
        dealOrders.push(sItem)
      })
      res.data.buyOrders.forEach((sItem) => {
        sItem.type = 'green'
        dealOrders.push(sItem)
      })
      dealOrders.sort(function (a, b) {
        return (b.date - a.date)
      });
      this.dealOrders = dealOrders
    },
    // 动态计算成交量宽度
    calculateBarWidth(quantity) {
      const maxQuantity = Math.max(...this.dealOrders.map(item => item.vol2)); // 最大值
      var result = quantity / maxQuantity
      result = result > 1 ? 1 : result
      return result * 100 + '%';
    },
    // 展示产品列表
    onShowProduct() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.searchValue = ''
      this.onSearch()
      this.showProList = true
    },
    // 获取客户端配置 配置支持产品类型
    async getConfig() {
      this.tabsType = [{
        name: this.$t('public').All,
        value: ""
      }]
      const res = await systemApi.getConfig()
      var productType = res.productType.split(',')
      productType.forEach((sItem) => {
        switch (sItem) {
          case "1":
            this.tabsType.push({
              name: this.$t('public').DigitalCurrency,
              value: "1"
            })
            break;
          case "2":
            this.tabsType.push({
              name: this.$t('public').foreignExchange,
              value: "2"
            })
            break;
          case "3":
            this.tabsType.push({
              name: this.$t('public').futures,
              value: "3"
            })
            break;
          case "4":
            this.tabsType.push({
              name: this.$t('public').stockIndex,
              value: "4"
            })
            break;
          case "5":
            this.tabsType.push({
              name: this.$t('public').stock,
              value: "5"
            })
            break;
        }
      })
    },
    //搜索
    onSearch() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.onGetProductList()
    },
    //获取产品行情/自选列表事件
    onGetProductList() {
      if (this.activeMarket == 0) this.getOptionalProductList()
      if (this.activeMarket == 1) this.getProductList()
    },
    //切换行情分类
    changeMarketTab(val) {
      this.activeMarket = val
      this.onSearch()
    },
    //切换产品业务
    changeBusinessTab(val) {
      this.activeBusiness = val
      if (this.activeBusiness != 2 && this.activeBusiness != 4)
        this.activeType = ''
      this.onSearch()
    },
    //切换产品类型
    changeTypeTab(val) {
      this.activeType = val
      this.onSearch()
    },
    // 单独添加删除自选产品
    async editSingleOptionalProduct(val) {
      this.proInfo.isOptional = val
      await productApi.editSingleOptionalProduct({ productId: this.productId, isOptional: val })
    },
    // 选择产品
    selectProduct(productId) {
      this.showProList = false
      this.productId = productId
      this.getProductInfo()
    },
    // 获取自选产品列表
    async getOptionalProductList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getOptionalProductList(this.parms)
      this.pList.push(...res.rows);
      if (this.pList.length > 0)
        this.showAddSelect = false
      else this.showAddSelect = true
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 获取产品列表
    async getProductList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getProductList(this.parms)
      this.pList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //产品详情
    async getProductInfo() {
      const res = await productApi.getProductInfo({ productId: this.productId })
      this.proInfo = res.data
      this.getProductDealList()
      this.webSocketInit(() => {
        this.websocketInfoGet()
      })
      this.$nextTick(() => {
        this.$refs.refTradingview.changeSymbol(this.proInfo); // 切换TV插件订阅的产品
        if (this.proInfo.isCloseTime)
          this.changedataMode(5)
      })
    },
    // 选择K线
    changedataMode(index) {
      this.dataMoeActiveIndex = index
      let resolution = this.dataModeList[this.dataMoeActiveIndex].value
      this.$refs.refTradingview.changeTabs(resolution); // 切换TV插件订阅的产品
      // this.line = this.dataModeList[this.dataMoeActiveIndex].value

    },
    //推送单品
    websocketInfoGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: [that.proInfo.symbol]
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        //产品详情
        let quotesInfo = reslult.find(item => item.Symbol == that.proInfo.symbol);
        if (quotesInfo) {
          that.proInfo.high = quotesInfo.High
          that.proInfo.low = quotesInfo.Low
          that.proInfo.newPrice = quotesInfo.NewPrice
          that.proInfo.volume = quotesInfo.Volume
          that.proInfo.priceChangeRatio = quotesInfo.PriceChangeRatio
        }
      })
    },
    //推送列表
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.pList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 产品列表
        that.pList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            sItem.newPrice = quotes.NewPrice
            sItem.volume = quotes.Volume
            sItem.priceChangeRatio = quotes.PriceChangeRatio
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-bottom: 80px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    width: 100%;
    background: var(--background_color);
    z-index: 1000;

    .exc {
      color: var(--text_color);
      width: 17px;
      height: 17px;
    }

    .title {
      width: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 17px;
      color: var(--text_color);

      span {
        margin-right: 5px;
      }

      .closetime {
        width: 10%;
        font-weight: normal;
        font-size: 10px;
        color: var(--ntext_color);
        margin-left: 10px;
      }
    }
  }

  .proNum {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px 15px 15px;
    background: var(--background_color);

    .left {
      width: 40%;

      .price {
        font-weight: 800;
        font-size: 25px;
        color: var(--text_color);
      }

      .flu {
        margin-top: 15px;
        font-weight: bold;
        font-size: 15px;
      }
    }

    .right {
      width: 50%;

      .num {
        padding: 5px 0;
        font-size: 12px;
        color: var(--ntext_color);
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          color: var(--text_color);
        }
      }
    }
  }

  .kBox {
    width: 100%;
    background: var(--background_color);
    margin-bottom: 10px;

    .data-mode-box {
      margin: 15px 0;
      display: flex;
      background: var(--background_color);

      div {
        flex: 1;
        color: var(--ntext_color);
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .dataMoeActive {
        font-weight: bold;
        color: var(--text_color);
      }
    }

    .tradingviewView {
      background: var(--background_color);
      width: 100%;
      height: 400px;
    }
  }

  .line {
    height: 7px;
    background: var(--info_color);
  }

  .positionTitle {
    display: flex;
    align-items: center;
    padding: 15px;
    font-weight: bold;
    font-size: 14px;
    color: var(--ntext_color);

    span {
      margin-right: 15px;
    }

    .active {
      color: var(--text_color);
    }
  }

  .orderBook {
    margin: 15px;

    .tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: var(--ntext_color);
      margin-bottom: 15px;
    }

    .orderRow {
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      font-size: 13px;

      .time {
        width: 30%;
        color: var(--text_color);
        text-align: left;
      }

      .price {
        width: 30%;
        text-align: center;
      }

      .quantity {
        width: 30%;
        color: var(--text_color);
        text-align: right;
      }

      .sellbar {
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: rgba(255, 0, 0, 0.1);
      }

      .buybar {
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: rgba(0, 255, 0, 0.1);
      }
    }

    .newprice {
      font-weight: bold;
      font-size: 17px;
      margin: 12px 0;
    }
  }

  .btns {
    position: fixed;
    bottom: 0;
    padding: 15px;
    width: 100%;
    height: 70px;
    background: var(--background_color);
    z-index: 999;
    pointer-events: auto;
    -webkit-tap-highlight-color: transparent;

    .van-button {
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: var(--background_color);
    }
  }

  .pro_list {
    ::v-deep .van-search__content {
      background-color: var(--info_color);
    }

    ::v-deep .van-cell {
      color: var(--text_color);
    }

    ::v-deep .van-field__control {
      color: var(--text_color);
    }

    background: var(--background_color);
    height: 90vh;

    .serarchInfo {
      width: 70%;
    }

    .topInfo {
      width: 100%;
      background: var(--background_color);
      padding-top: 10px;

      .proTab {
        padding: 12px 15px;
        font-size: 17px;
        font-weight: bold;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);

        span {
          margin-right: 20px;
        }

        .active {
          color: var(--text_color);
        }
      }

      .protypeTab {
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          padding: 12px 0;

          span {
            margin-right: 20px;
          }

          .active {
            color: var(--text_color);
            padding-bottom: 10px;
            border-bottom: 2px solid var(--text_color);
          }
        }

        .svgs {
          width: 18px;
          height: 18px;
          color: var(--text_color);
        }
      }

      .tabs {
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        font-size: 13px;
        padding: 8px 15px;
        border-bottom: 1px solid var(--info_color);

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px 10px;
          margin-right: 10px;
        }

        .active {
          background: var(--info_color);
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px 10px;
          color: var(--text_color);
        }
      }

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--ntext_color);
        padding: 0 15px;
        font-size: 12px;
        height: 50px;

        .name {
          width: 30%;
          text-align: left;
        }

        span {
          width: 20%;
          text-align: right;
        }
      }
    }

    .addSelectBtn {
      margin: 100px 15px 85px 15px;

      .van-button {
        margin-top: 20px;
        background: var(--text_color);
        height: 40px;
        border-radius: 20px;
        border: 0;
        font-size: 15px;
        color: var(--background_color);
      }
    }

    .productInfo {
      padding: 0 15px 15px 15px;
      // height: calc(90vh - 250px);
      overflow-y: scroll;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        color: var(--text_color);
        font-size: 13px;

        .name {
          font-weight: bold;
          width: 30%;
          text-align: left;
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        span {
          width: 20%;
          text-align: right;
        }

        .ratio {
          width: 20%;
          padding: 5px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          border-radius: 5px;
        }

        &:active {
          background: var(--info_color);
        }
      }
    }
  }
}

::v-deep .van-dialog {
  background-color: transparent;
}

::v-deep .van-popup--left {
  top: 65px;
  height: calc(100vh - 60px) !important;
  overflow: 'hidden';
  width: 90%;
  transform: translate3d(0, 0, 0);
  border-radius: 0 10px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
